import { useState } from 'react';

const PAINS = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Cho thuê rẻ — sai mô hình',
    desc: 'Nhà vẫn đang có thuê, nhưng dòng tiền chỉ bằng 30–40% tiềm năng thực sự vì sai mô hình khai thác.',
    loss: '–60% dòng tiền',
  },
  {
    icon: 'ri-time-line',
    title: 'Bán lâu không được giá',
    desc: 'Nhà rao 6–12 tháng, phải giảm giá mà vẫn không chốt được vì không có chiến lược định vị đúng.',
    loss: '–15–25% giá trị',
  },
  {
    icon: 'ri-building-2-line',
    title: 'Xây đẹp nhưng trống căn',
    desc: 'Đầu tư xây dựng tốt nhưng không vận hành được hoặc công suất thuê quá thấp, hoàn vốn kéo dài.',
    loss: '–50% lợi suất',
  },
];

function PainCard({ pain }: { pain: typeof PAINS[0] }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className="bg-white rounded-2xl p-8 border border-[#E5E7EB] hover:border-[#C5A059]/40 transition-all duration-300 group/pain cursor-pointer"
      onClick={() => setOpen(v => !v)}
    >
      <div className="w-12 h-12 flex items-center justify-center bg-[#E6F0F0] rounded-xl mb-5 group-hover/pain:bg-[#C5A059]/[0.15] transition-colors">
        <i className={`${pain.icon} text-2xl text-[#004D4D]`} />
      </div>
      <div className="flex items-start justify-between gap-2 mb-0">
        <h3 className="font-heading font-bold text-lg text-[#004D4D]">{pain.title}</h3>
        <i className={`ri-arrow-down-s-line text-[#004D4D]/40 text-lg flex-shrink-0 mt-0.5 transition-transform duration-200 ${open ? 'rotate-180' : ''} md:group-hover/pain:rotate-180`} />
      </div>
      {/* Mobile toggle */}
      <div className={`md:hidden overflow-hidden transition-all duration-300 ${open ? 'max-h-32 opacity-100 mt-3 mb-5' : 'max-h-0 opacity-0 mt-0 mb-0'}`}>
        <p className="text-[#374151] text-sm font-sans leading-relaxed">{pain.desc}</p>
      </div>
      {/* Desktop hover */}
      <div className="hidden md:block overflow-hidden max-h-0 opacity-0 group-hover/pain:max-h-32 group-hover/pain:opacity-100 group-hover/pain:mt-3 group-hover/pain:mb-5 transition-all duration-300">
        <p className="text-[#374151] text-sm font-sans leading-relaxed">{pain.desc}</p>
      </div>
      <div className="inline-flex items-center gap-2 bg-red-50 text-red-600 text-xs font-bold px-3 py-1.5 rounded-full font-heading mt-3">
        <i className="ri-arrow-down-line text-sm" />
        {pain.loss}
      </div>
    </div>
  );
}

export default function InsightSection() {
  return (
    <section id="insight" className="bg-[#F2F4F5] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">

        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#C5A059] text-xs font-heading font-bold tracking-widest uppercase">
            VẤN ĐỀ THỰC TẾ
          </span>
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-[#004D4D] mt-3 mb-5 leading-tight">
            Tài sản đang bị bỏ phí<br />ngay trước mắt bạn
          </h2>
          <p className="text-[#374151] text-base font-sans leading-relaxed">
            Hầu hết chủ nhà không biết rằng tài sản của họ đang mất tiền mỗi tháng — không phải vì thị trường xấu, mà vì sai mô hình.
          </p>
        </div>

        {/* Pain Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {PAINS.map((pain) => (
            <PainCard key={pain.title} pain={pain} />
          ))}
        </div>

        {/* Highlight Message */}
        <div className="bg-[#004D4D] rounded-2xl p-10 md:p-14 text-center">
          <div className="max-w-2xl mx-auto">
            <div className="w-14 h-14 flex items-center justify-center bg-[#C5A059]/20 rounded-full mx-auto mb-6">
              <i className="ri-lightbulb-flash-line text-3xl text-[#C5A059]" />
            </div>
            <h3 className="font-heading font-extrabold text-2xl md:text-3xl text-white mb-4 leading-tight">
              Bạn không thiếu tài sản —<br />
              <span className="text-[#C5A059]">bạn đang thiếu mô hình đúng</span>
            </h3>
            <p className="text-white/70 text-base font-sans leading-relaxed mb-8">
              Đất trống, nhà phố cũ, villa xuống cấp, hay căn đang cho thuê rẻ — tất cả đều có tiềm năng sinh dòng tiền vượt trội nếu được thiết kế đúng mô hình.
            </p>
            <a
              href="/bat-mach-tai-san"
              className="inline-flex items-center gap-2 bg-[#C5A059] hover:bg-[#D4B575] text-[#002626] font-heading font-bold text-sm px-8 py-4 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Kiểm Tra Tài Sản Của Bạn
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
